import Vue from 'vue'
import iview from '@/assets/vendor/view-design/src'

Vue.use(iview)
